import React from "react";
import {
    Checkbox,
    InputAdornment,
    TableCell,
    TableRow,
    TextField,
} from "@material-ui/core";
import { withTranslation } from 'react-i18next';

export const PasoForm = withTranslation()(function PasoForm({ paso, defaultValueUmbral, visible, order, t }) {
    const [umbral, setUmbral] = React.useState(defaultValueUmbral);
    const [inputError, setInputError] = React.useState(null);
    const [visibilidad, setVisibilidad] = React.useState(visible);

    function onChange(event) {
        const { value } = event.target;
        let error = null;
        if (isNaN(Number(value) || value === "")) {
            error = t('flashboard.objective.input.invalid');
        } else if (value <= 0) {
            error = t('flashboard.objective.input.minError');
        } else if (!/^[0-9]*$/.test(value)) {
            error = t('flashboard.objective.input.integerError');
        }
        setInputError(error);
        if (!isNaN(Number(value))) {
            setUmbral(value);
        }
    }

    const handleChangeVisibilidad = (event) => {
        setVisibilidad(event.target.checked);
    };

    function preventPaste(e) {
        e.preventDefault();
        return false;
    }

    return (
        <TableRow>
            <TableCell>
                {paso}
                <input type="hidden" name="order" value={order} />
            </TableCell>
            <TableCell>
                <TextField
                    error={Boolean(inputError)}
                    required
                    value={umbral}
                    onChange={onChange}
                    type="number"
                    variant="outlined"
                    size="small"
                    name="umbral"
                    InputProps={{
                        inputProps: {
                            min: 1,
                        },
                        endAdornment: (
                            <InputAdornment position="end">{t('flashboard.unit.seconds')}</InputAdornment>
                        ),
                    }}
                    helperText={inputError}
                    onKeyDown={(e) =>["e", "E", "+", "-", ".", "´", "¨", "`"].includes(e.key) && e.preventDefault()}
                    onPaste={preventPaste}
                />
            </TableCell>
            <TableCell>
                <Checkbox
                    checked={visibilidad}
                    onChange={handleChangeVisibilidad}
                    color="primary"
                    name="checkVisibilidad"
                />
            </TableCell>
        </TableRow>
    );
});
